module.exports = __webpack_public_path__ + "img/nodata_market.2b9a3933.png";